import { COPY } from '@/shared/constants/copies';
import { TFormStatus } from '@/shared/services/forms/forms.types';

import { TAnalyticsTimeInterval } from '../types/analytics-types';

export const TIME_INTERVAL_OPTIONS: Array<{
	label: string;
	value: TAnalyticsTimeInterval;
}> = [
	{ label: 'Last 7 days', value: 'LAST_7_DAYS' },
	{ label: 'Last 30 days', value: 'LAST_30_DAYS' },
	{ label: 'Last 90 days', value: 'LAST_90_DAYS' },
];

export const DEFAULT_TIME_INTERVAL: TAnalyticsTimeInterval = 'LAST_30_DAYS';

export const FORM_SUMMARIES_PAGE_SIZE = 15;

export const CHART_COLORS = {
	primary: 'hsl(var(--chart-1))',
	secondary: 'hsl(var(--chart-2))',
	tertiary: 'hsl(var(--chart-3))',
	quaternary: 'hsl(var(--chart-4))',
	quinary: 'hsl(var(--chart-5))',
} as const;

export const CHART_CONFIG = {
	reviewRate: {
		label: 'Review rate',
		color: CHART_COLORS.primary,
	},
	responseRate: {
		label: 'Response rate',
		color: CHART_COLORS.secondary,
	},
	avgReviewTime: {
		label: 'Avg review time',
		color: CHART_COLORS.tertiary,
	},
	avgResponseTime: {
		label: 'Avg response time',
		color: CHART_COLORS.quaternary,
	},
	candidates: {
		label: 'Candidates',
		color: CHART_COLORS.primary,
	},
	views: {
		label: 'Views',
		color: CHART_COLORS.secondary,
	},
} as const;

export const METRIC_LABELS = {
	totalViews: 'Views',
	totalCandidates: 'Candidates',
	totalSubmissions: 'Submissions',
	reviewRate: 'Review rate',
	responseRate: 'Response rate',
	avgReviewTime: 'Avg review time',
	avgResponseTime: 'Avg response time',
	totalReviewed: 'Reviewed',
	totalResponded: 'Responded',
	viewsAndSubmissions: 'Views & Submissions',
	candidateFunnel: 'Candidate funnel',
	formConversion: 'Form conversion',
} as const;

const { analytics } = COPY;

export const METRIC_HELPER_TEXTS = {
	totalViews: analytics.totalViewsHelp,
	totalCandidates: analytics.totalCandidatesHelp,
	totalSubmissions: analytics.totalSubmissionsHelp,
	reviewRate: `${analytics.reviewRateHelp} ${analytics.formApplicantsOnly}`,
	responseRate: `${analytics.responseRateHelp} ${analytics.formApplicantsOnly}`,
	avgReviewTime: `${analytics.avgReviewTimeHelp} ${analytics.formApplicantsOnly}`,
	avgResponseTime: `${analytics.avgResponseTimeHelp} ${analytics.formApplicantsOnly}`,
	viewsAndSubmissions: analytics.viewsToSubmissionsHelp,
	candidateFunnel: analytics.candidateFunnelHelp,
	avgTimeToReachStage: analytics.avgTimeToReachStageHelp,
	formConversion: analytics.viewsToSubmissionsHelp,
} as const;

export const ANALYTICS_CACHE_TIME = {
	PAGE_ANALYTICS: 5 * 60 * 1000,
	FORM_SUMMARIES: 5 * 60 * 1000,
	FORM_ANALYTICS: 5 * 60 * 1000,
} as const;

export const SOCIAL_MEDIA_NAMES: Record<string, string> = {
	TWITTER: 'Twitter',
	INSTAGRAM: 'Instagram',
	LINKEDIN: 'LinkedIn',
	LINKTREE: 'Linktree',
	FACEBOOK: 'Facebook',
	GOOGLE: 'Google',
};

export const FORM_STATUS_BADGE_TEXT: Record<TFormStatus, string> = {
	PUBLISHED: 'Live',
	DRAFT: 'Draft',
	CLOSED: 'Closed',
};
